import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

import { SentryUtils } from '@shared/modules/sentry/utils';

SentryUtils.init();

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);

  root.render(<App />);
}
